module.exports = __webpack_public_path__ + "img/IT0002846500661.9d4a0ee5.png";